import pythonApiClient from './pythonBaseApi';

// Usar cliente base compartido de Python API
const basePath = '/mantenimientos/modulos';

export const moduloApi = {
  // Obtener todos los módulos
  getModulos: async (zonaId = null, estadoId = null) => {
    const params = {};
    if (zonaId) params.zona_id = zonaId;
    if (estadoId) params.estado_modulo_id = estadoId;
    return pythonApiClient.get(`${basePath}/`, { params });
  },

  // Obtener módulos con estadísticas
  getModulosWithStats: async (zonaId = null, estadoId = null) => {
    const params = {};
    if (zonaId) params.zona_id = zonaId;
    if (estadoId) params.estado_modulo_id = estadoId;
    return pythonApiClient.get(`${basePath}/stats`, { params });
  },

  // Obtener módulo por ID
  getModuloById: async (moduloId) => {
    return pythonApiClient.get(`${basePath}/${moduloId}`);
  },

  // Obtener módulo con relaciones
  getModuloWithRelations: async (moduloId) => {
    return pythonApiClient.get(`${basePath}/${moduloId}/relations`);
  },

  // Obtener estadísticas de un módulo
  getModuloStatistics: async (moduloId) => {
    return pythonApiClient.get(`${basePath}/${moduloId}/statistics`);
  },

  // Obtener categorías permitidas de un módulo
  getModuloCategorias: async (moduloId) => {
    return pythonApiClient.get(`${basePath}/${moduloId}/categorias`);
  },

  // Obtener géneros permitidos de un módulo
  getModuloGeneros: async (moduloId) => {
    return pythonApiClient.get(`${basePath}/${moduloId}/generos`);
  },

  // Crear módulo
  createModulo: async (moduloData) => {
    return pythonApiClient.post(`${basePath}/`, moduloData);
  },

  // Actualizar módulo
  updateModulo: async (moduloId, moduloData) => {
    return pythonApiClient.put(`${basePath}/${moduloId}`, moduloData);
  },

  // Eliminar módulo
  deleteModulo: async (moduloId) => {
    return pythonApiClient.delete(`${basePath}/${moduloId}`);
  },

  // Obtener módulos por zona
  getModulosByZona: async (zonaId) => {
    return pythonApiClient.get(`${basePath}/zona/${zonaId}`);
  },

  // Buscar módulo por código
  getModuloByCodigo: async (codigo) => {
    return pythonApiClient.get(`${basePath}/codigo/${codigo}`);
  },
};

export default moduloApi;